export type ManageArea = 'site' | 'design' | 'code' | 'health';

export const MANAGE_AREAS: Array<[ManageArea, string]> = [
  ['site', 'Site'],
  ['design', 'Design'],
  ['code', 'Code & tracking'],
  ['health', 'Site health'],
];

export const isManageArea = (v: unknown): v is ManageArea => MANAGE_AREAS.some(([k]) => k === v);

/** Where a Manage area lives; `hash` scrolls to one section of it. */
export const manageUrl = (area: ManageArea = 'site', hash?: string) =>
  `/content?view=manage&area=${area}${hash ? `#${hash}` : ''}`;

export const ARTICLE_SETTINGS_PATH = '/content/settings';
export const FORM_SETTINGS_PATH = '/content/forms/settings';
export const PAGE_SETTINGS_PATH = '/content/pages/settings';
export const MEDIA_SETTINGS_PATH = '/content/media/settings';

/** The Website header's button on a tab with its own settings (Round 44 §1). */
export const TYPE_SETTINGS: Record<string, { label: string; to: string; tip: string }> = {
  articles: {
    label: 'Article settings',
    to: ARTICLE_SETTINGS_PATH,
    tip: 'Custom fields, web addresses and the copy edit',
  },
  pages: {
    label: 'Page settings',
    to: PAGE_SETTINGS_PATH,
    tip: 'How pages go live',
  },
  forms: {
    label: 'Form settings',
    to: FORM_SETTINGS_PATH,
    tip: 'How long responses are kept, spam protection and small print',
  },
  media: {
    label: 'Media settings',
    to: MEDIA_SETTINGS_PATH,
    tip: 'Alt text, originals and upload size',
  },
};

/**
 * Areas Manage had until backlog 46b884ba, for old links: per-type settings moved
 * to a settings button on their tab. Overview had nothing of its own.
 */
const MOVED_AREAS: Record<string, string> = {
  overview: manageUrl('site'),
  pages: PAGE_SETTINGS_PATH,
  articles: ARTICLE_SETTINGS_PATH,
  media: MEDIA_SETTINGS_PATH,
  forms: FORM_SETTINGS_PATH,
};

export const movedManageArea = (area: string | null, hash = '') =>
  area && MOVED_AREAS[area] ? `${MOVED_AREAS[area]}${hash}` : null;
